/**
 * Badge artwork image imports — AI-generated enamel pin illustrations.
 */
import firstSip from '@/assets/badges/first-sip.png';
import neighborhoodHopper from '@/assets/badges/neighborhood-hopper.png';
import localLegend from '@/assets/badges/local-legend.png';
import crossTown from '@/assets/badges/cross-town.png';
import dawnPatrol from '@/assets/badges/dawn-patrol.png';
import nightOwl from '@/assets/badges/night-owl.png';
import inTheZone from '@/assets/badges/in-the-zone.png';
import flowState from '@/assets/badges/flow-state.png';
import theRegular from '@/assets/badges/the-regular.png';
import mondayMotivation from '@/assets/badges/monday-motivation.png';
import storyteller from '@/assets/badges/storyteller.png';
import photographer from '@/assets/badges/photographer.png';
import trustedVoice from '@/assets/badges/trusted-voice.png';
import firstFoot from '@/assets/badges/first-foot.png';
import caffeineTour from '@/assets/badges/caffeine-tour.png';
import laptopWarrior from '@/assets/badges/laptop-warrior.png';
import foundingMember from '@/assets/badges/founding-member.png';

export const badgeImageMap: Record<string, string> = {
  first_sip: firstSip,
  founding_member: foundingMember,
  neighborhood_hopper: neighborhoodHopper,
  local_legend: localLegend,
  cross_town: crossTown,
  dawn_patrol: dawnPatrol,
  night_owl: nightOwl,
  in_the_zone: inTheZone,
  flow_state: flowState,
  the_regular: theRegular,
  monday_motivation: mondayMotivation,
  storyteller: storyteller,
  photographer: photographer,
  trusted_voice: trustedVoice,
  first_foot: firstFoot,
  caffeine_tour: caffeineTour,
  laptop_warrior: laptopWarrior,
};
